import api, { getAuthParams } from './client';

export const getFilings = (params) =>
  api.get('/filings', { params: { ...getAuthParams(), ...params } });

/** Table list / single row — POST only (multi-select filters as arrays in body). */
export const getSnapshots = (params) =>
  api.post('/snapshots', { ...getAuthParams(), ...params });

export const getSnapshotOptions = (params) =>
  api.get('/snapshots/options', { params: { ...getAuthParams(), ...params } });

export const getEvents = (params) =>
  api.get('/events', { params: { ...getAuthParams(), ...params } });

export const getFilingsInsights = (payload) =>
  api.post('/filings/insights', { ...payload, ...getAuthParams() });

export const getFilingsScopeConfig = (params) =>
  api.get('/filings/scope-config', { params: { ...getAuthParams(), ...params } });
